import objectAssign from 'object-assign';


export function articles( state = { 
	all: [],
	fetching: false
}, action ) {

	switch( action.type ) {

		case 'REQUEST_ARTICLES':
			return Object.assign({}, state, {
				fetching: true
			})

		case 'RECEIVE_ARTICLES':
			return Object.assign({}, state, {
				fetching: false,
				all: action.articles
			})

		case 'REFRESH_ARTICLES':
			return Object.assign({}, state, {
				fetching: false,
				all: state.all
			})

		case 'RECEIVE_UPDATED_ARTICLE':
			let articles = state.all;
			for (var a = 0; a < articles.length; a++) {
				if( articles[a].ID === action.article ) articles[a] = action.article
			}
			return Object.assign({}, state, {
				fetching: false,
				all: articles
			})

		default:
			return state;

	}
	
}



// WEBPACK FOOTER //
// ./src/js/reducers/articles.js